import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

export interface SectionLabelProps {
    /** Eyebrow text, e.g. "(01 – Projects)", "(About)", "(04 – Articles)". */
    children: ReactNode;
    className?: string;
}

/**
 * Small eyebrow label that prefixes homepage sections (Neue Haas Roman, 2rem on
 * desktop and a vw scale on mobile). Defaults to the dark ink colour; pass
 * `text-white` via className on dark sections. Positioning and any per-section
 * size override are left to the consuming section.
 */
export const SectionLabel = ({ children, className }: SectionLabelProps) => (
    <span
        className={cn(
            'font-sans font-normal leading-[1.07] tracking-[-0.044em] text-[#181818] max-md:text-[2.21vw] md:text-8',
            className,
        )}
    >
        {children}
    </span>
);
